import React from 'react';
import Footer from './Footer';
import Header from './Header';

const BaseProfile = (props) => (
  <>
    <Header />
    {props.children}
    <Footer />
  </>
);

export default BaseProfile;
